import React from 'react';

export default function AuthorContact(props) {
  const elementRef = React.useRef();

  React.useEffect(() => {
    elementRef.current.href = 'mailto:' + props.email;
    elementRef.current.innerText = props.email;
  }, [props.email]);

  return (
    <p className="author-contact">
      Epost:{' '}
      <a href="/" ref={elementRef}>
        epost
      </a>
    </p>
  );
}
